import { Services } from '@sigma-frontend-libs/commons'
import { MODERATION_VALUES } from '@sigma-legacy-libs/essentials/lib/constants'

import { components, moderationColors, moderationIcons, prioritizeAccountInList, sizes } from '@/utils'

import squircle from '@/components/icon/squircle'
import rulesTemplate from '@/components/rules/template'
import { ruleTags, ruleTypes } from '@/components/rules/utils'
import selectorOwner from '@/components/selector/owner'
import sendingsCreateForm from '@/components/services/sendingsCreate/form'
import tag from '@/components/tag'

function renderIsActiveField(h) {
  if (this.canUpdatePatternsAsAdmin) {
    return h(
      components.switch,
      {
        props: {
          value: this.proxy.isActive,
          outline: true,
          tooltip: this.getTranslate(`${Services.patterns}.labels.isActive`)
        },
        on: {
          input: event => {
            this.proxy.isActive = event
          }
        }
      }
    )
  }
}
function renderTitleField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.title,
        label: this.getTranslate(`${Services.patterns}.labels.title`),
        dense: true,
        required: true,
        autofocus: true,
        details: false
      },
      on: {
        input: event => {
          this.proxy.title = event
        }
      }
    }
  )
}
function renderTitle(h) {
  return h(
    'div',
    {
      class: {
        [`${Services.patterns}-form__title`]: true,
        [`${Services.patterns}-form__title--admin`]: this.canUpdatePatternsAsAdmin
      }
    },
    [
      renderTitleField.call(this, h),
      renderIsActiveField.call(this, h)
    ]
  )
}
function renderModerationField(h) {
  return h(
    components.select,
    {
      props: {
        value: this.proxy.moderation,
        label: this.getTranslate(`${Services.patterns}.labels.moderation`),
        items: MODERATION_VALUES.map(moderation => {
          return {
            title: this.getTranslate(`misc.moderation.${moderation}`),
            value: moderation,
            icon: moderationIcons[moderation],
            iconColor: moderationColors[moderation]
          }
        }),
        dense: true,
        required: true,
        details: false
      },
      on: {
        input: event => {
          this.proxy.moderation = event
        }
      },
      scopedSlots: {
        selection: ({ item }) => {
          return h(
            tag,
            {
              props: {
                label: this.getTranslate(`misc.moderation.${item.value}`),
                color: moderationColors[item.value],
                as: 'select-dense'
              }
            }
          )
        }
      }
    }
  )
}
function renderModerationIcon(h) {
  return h(
    squircle,
    {
      props: {
        iconSize: 30,
        size: sizes.medium,
        icon: moderationIcons[this.proxy.moderation],
        color: moderationColors[this.proxy.moderation]
      }
    }
  )
}
function renderModeration(h) {
  if (this.canUpdatePatternsAsResellerUp) {
    return h(
      'div',
      {
        class: `${Services.patterns}-form__moderation`
      },
      [
        renderModerationField.call(this, h),
        renderModerationIcon.call(this, h)
      ]
    )
  }
}
function renderOwnerField(h) {
  return h(
    selectorOwner,
    {
      props: {
        value: this.proxy.OwnerId,
        clearItems: prioritizeAccountInList,
        dense: true
      },
      on: {
        input: event => {
          this.proxy.OwnerId = event
        }
      }
    }
  )
}

function renderSendingForm(h) {
  return h(
    sendingsCreateForm,
    {
      props: {
        value: this.proxy,
        service: Services.patterns
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    }
  )
}

function renderCheckField(h) {
  return h(
    components.textarea,
    {
      props: {
        value: this.check,
        label: this.getTranslate(`${Services.patterns}.labels.check`),
        hint: this.getTranslate(`${Services.patterns}.hints.check`),
        disabled: !this.proxy.payload.text,
        dense: true
      },
      on: {
        input: event => {
          this.check = event
        }
      }
    }
  )
}
function renderCheckIcon(h) {
  return h(
    squircle,
    {
      props: {
        iconSize: 28,
        size: sizes.medium,
        icon: this.patternValidationIcon,
        color: this.patternValidationColor,
        tooltip: this.patternValidationTooltip
      }
    }
  )
}
function renderCheck(h) {
  return h(
    'div',
    {
      class: `${Services.patterns}-form__check`
    },
    [
      renderCheckField.call(this, h),
      renderCheckIcon.call(this, h)
    ]
  )
}

function renderConditions(h) {
  return h(
    rulesTemplate,
    {
      props: {
        value: this.proxy.conditions,
        whitelist: [ ruleTags.mccmnc ],
        ruleType: ruleTypes.conditions
      },
      on: {
        input: event => {
          this.$set(this.proxy, 'conditions', event)
        }
      }
    }
  )
}

function renderComments(h) {
  return h(
    'div',
    {
      class: `${Services.patterns}-form__comments`
    },
    [
      this.commentFields.map(field => {
        return h(
          components.textarea,
          {
            props: {
              value: this.proxy.meta[field],
              label: this.getTranslate(`${Services.patterns}.labels.meta.${field}`),

              grow: true,
              dense: true,
              clearable: true,
              details: false
            },
            on: {
              input: event => {
                this.proxy.meta[field] = event
              }
            }
          }
        )
      })
    ]
  )
}

export default function(h) {
  return h(
    components.form,
    {
      class: {
        [`${Services.patterns}-form`]: true,
        [`${Services.patterns}-form--new`]: this.isNew
      }
    },
    [
      renderTitle.call(this, h),
      renderModeration.call(this, h),
      renderOwnerField.call(this, h),
      renderSendingForm.call(this, h),
      renderCheck.call(this, h),
      renderConditions.call(this, h),
      renderComments.call(this, h)
    ]
  )
}
